import React, { useRef, useState } from "react";
import { BmModal, Btn, Field, TextArea } from "../../ForBrands/ui/BrandUI";
import { usePhoneTheme } from "../../ForBrands/useIsPhone";

// Athlete Mode · decline a brand's offer. Shared by the offer view and the
// contract review so both pages ask the same way: a short optional reason,
// "Keep it open" to back out, and the critical "Decline offer" button.
// Focus opens on "Keep it open", the safe choice, and BmModal hands it back
// to the control that opened the dialog. onConfirm receives the reason as
// typed (possibly empty).
// On phones BmModal opens it as a bottom sheet with the two actions stacked
// ("Decline offer" on top); `bm-phone-form` gives the reason the 140px, 16px
// phone textarea.
const DeclineModal = ({ onClose, onConfirm, busy = false }) => {
  const [reason, setReason] = useState("");
  const keepRef = useRef(null);
  const phone = usePhoneTheme();
  return (
    <BmModal
      title="Decline this offer"
      onClose={onClose}
      initialFocusRef={keepRef}
      className={phone ? "bm-phone-form" : undefined}
      footer={
        <>
          <Btn ref={keepRef} variant="secondary" className="flex-1" onClick={onClose}>
            Keep it open
          </Btn>
          <Btn className="flex-1 !bg-bm-critical hover:!bg-[#c41d14]" disabled={busy} onClick={() => onConfirm(reason)}>
            {busy ? "Declining..." : "Decline offer"}
          </Btn>
        </>
      }
    >
      <p className="bm-body-m text-bm-muted">
        The brand is notified right away. A short reason helps them come back with a better fit next time.
      </p>
      <Field label="Reason (optional)" className="mt-4">
        <TextArea rows={3} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Timing, exclusivity, budget..." />
      </Field>
    </BmModal>
  );
};

export default DeclineModal;
